import React, { useState } from "react";
import ReactStars from "react-rating-stars-component";
import loader from "../assets/image/half-circle.gif";
import { withTranslation } from "react-i18next";

const ProgressBar = ({ progress }) => {
  const Childdiv = {
    height: "100%",
    width: `${progress}%`,
    backgroundColor: "#FFF700",
    borderRadius: 40,
    textAlign: "right",
  };
  return <div style={Childdiv}></div>;
};
const formatDate = (date) => {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();
  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  let dateStr = [day, month, year].join(".");
  dateStr = `${dateStr} at ${date.toLocaleString("en-US", {
    hour: "numeric", // numeric, 2-digit
    minute: "numeric", // numeric, 2-digit
  })}`;
  return dateStr;
};
const RatingsReviews = (props) => {
  const [isViewAll, setIsViewAll] = useState(false);
  const { modalOpen, ratingData, ratingLoading } = props;
  // console.log("ratingData", ratingData);
  const setViewAll = (value) => {
    setIsViewAll(value);
  };
  let { count_wise_rating, total_rating_count, ratings_and_reviews } =
    ratingData;
  let arr = [];
  let ratingInfo = [];
  if (ratingData && ratingData.count_wise_rating) {
    // console.log("count_wise_rating", count_wise_rating);
    arr = [...count_wise_rating];
    arr.map((each) => (each.star_rating = Math.round(each.star_rating)));
    if (count_wise_rating > 5) {
      for (let index = 0; index < count_wise_rating.length; index++) {
        if (!arr.find((each) => index === each.star_rating)) {
          arr.splice(index, 0, { star_rating: index, total: 0 });
        }
      }
    } else {
      for (let index = 0; index < 6; index++) {
        if (!arr.find((each) => index === each.star_rating)) {
          arr.splice(index, 0, { star_rating: index, total: 0 });
        }
      }
    }
    arr.sort((a, b) => {
      if (a.star_rating > b.star_rating) {
        return 1;
      }
      if (a.star_rating < b.star_rating) {
        return -1;
      }
      return 0;
    });
    for (let index = 1; index < arr.length; index++) {
      const element = arr[index];
      // console.log("ELEMENT",element,"index",index)
      if (element && element.star_rating)
        if (element && element.star_rating && index !== element.star_rating) {
          // console.log("element.star_rating > index",element.star_rating > index,element.star_rating , index)
          if (element.star_rating > index || element.star_rating <= index - 1) {
            if (index !== 0) {
              arr[index - 1] = {
                star_rating: arr[index - 1].star_rating,
                total: arr[index - 1].total + arr[index].total,
              };
            }
            arr.splice(index, 1);
          }
        }
    }
    arr = arr.filter((each) => {
      if (each.star_rating && each.star_rating > 0 && each.star_rating < 6) {
        return each;
      }
      return 0;
    });

    arr.sort((a, b) => {
      if (a.star_rating > b.star_rating) {
        return -1;
      }
      if (a.star_rating < b.star_rating) {
        return 1;
      }
      return 0;
    });
  }
  if (ratingData && ratingData.ratings_and_reviews)
    ratingInfo = [...ratings_and_reviews];
  if (ratingInfo && ratingInfo.length > 5) {
    if (!isViewAll) {
      ratings_and_reviews = ratings_and_reviews.slice(0, 5);
    }
  }
  const { t } = props;
  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-header-title">{t("Ratings & Reviews")}</h3>
      </div>
      {ratingLoading ? (
        <div className="card-loader">
          <img src={loader} alt="loading..." />
        </div>
      ) : (
        <div className="card-body">
          <div className="card-ratings-reviews">
            <div className="card-write-review">
              <div className="stars write-review-star">
                <ReactStars
                  size={43}
                  value={
                    ratingData && ratingData.average_rating
                      ? Number(ratingData.average_rating.toFixed(2))
                      : 0
                  }
                  edit={false}
                  isHalf={true}
                  color="#ececec"
                  activeColor="#FFF700"
                  emptyIcon={<i className="far fa-star"></i>}
                  halfIcon={<i className="fa fa-star-half-alt"></i>}
                  fullIcon={<i className="fa fa-star"></i>}
                  // onChange={this.ratingChanged}
                />
                {/* <ReactStars {...writeRivew} /> */}
              </div>
              <h4 className="card-write-review-title">
                <span>
                  {ratingData && ratingData.average_rating
                    ? Math.round(ratingData.average_rating * 10) / 10
                    : 0}
                </span>
                /5
              </h4>
              <p className="card-write-review-note">
                <span>{ratingData.total_rating_count}</span> {t("Ratings")} &{" "}
                <span>{ratingData.total_review_count}</span> {t("Reviews")}
              </p>
              <button onClick={modalOpen} id="myBtn" className="btn">
                {t("WRITE A REVIEW")}
              </button>
            </div>
            {ratingData && ratingData.average_rating ? (
              <div className="card-display-review">
                <div className="card-display-review-list">
                  {arr && arr.length
                    ? arr.map((each, index) => {
                        let pr = (each.total * 100) / total_rating_count;
                        return (
                          <div className="card-display-review-item" key={index}>
                            <span className="card-display-review-item-text">
                              {each.star_rating} <span className="fa fa-star" />
                            </span>
                            <div className="progress-bar">
                              <div className="progress-bar-line">
                                <ProgressBar progress={pr} />
                              </div>
                            </div>
                            <span className="card-display-review-item-text">
                              {each.total}
                            </span>
                          </div>
                        );
                      })
                    : null}
                </div>
              </div>
            ) : null}
          </div>
          <div className="card-comment-list">
            {ratings_and_reviews && ratings_and_reviews.length
              ? ratings_and_reviews.map((each, index) => {
                  let name = each.reviewer_name
                    ? each.reviewer_name.split(" ")
                    : "";
                  let word = name
                    ? name.length > 1
                      ? `${name[0][0]}${name[1][0]}`
                      : name[0][0]
                    : "";
                  let date = formatDate(new Date(each.rated_date));
                  return (
                    <div className="card-comment-item" key={index}>
                      <div className="card-comment-profile">
                        <span className="card-comment-profile-short-name">
                          {word ? word : ""}
                        </span>
                      </div>
                      <div className="card-comment-right">
                        <h4 className="card-comment-username">
                          {each.reviewer_name}
                        </h4>
                        <div className="card-comment-rating-star-date">
                          <div className="stars comments-rating-star">
                            <ReactStars
                              size={22}
                              value={each.star_rating}
                              edit={false}
                              isHalf={true}
                              color="#ececec"
                              activeColor="#FFF700"
                            />
                          </div>
                          <span className="card-comment-date">{date}</span>
                        </div>
                        <p className="card-comment-content">{each.review}</p>
                        {each.feedback ? (
                          <div>
                            <div className="feedback">
                              <div className="test"></div>
                              <p className="card-comment-content">
                                {each.feedback}
                              </p>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  );
                })
              : null}
          </div>
          <div className="card-comment-footer">
            {ratingInfo && ratingInfo.length > 5 ? (
              isViewAll ? (
                <span
                  onClick={() => setViewAll(false)}
                  className="card-comment-view-link"
                >
                  View Less
                </span>
              ) : (
                <span
                  onClick={() => setViewAll(true)}
                  className="card-comment-view-link"
                >
                  View All
                </span>
              )
            ) : null}
          </div>
        </div>
      )}
    </div>
  );
};

export default withTranslation()(RatingsReviews);
